<template>
  <van-popup
    :value="show"
    @close="updateValue"
    class="draw-wrap"
    @click-overlay="updateValue"
    position="bottom"
  >
    <div class="notice-wrap">
      <svg-icon iconClass="matter-notice" class="notice-icon" />
      <div class="notice-text-wrap-container">
        <div class="notice-text-wrap">
          <span class="notice-text">
            温馨提示，内蒙古、吉林、甘肃、青海、宁夏、海南需收取额外运费。
          </span>
          <span class="notice-text">
            温馨提示，内蒙古、吉林、甘肃、青海、宁夏、海南需收取额外运费。
          </span>
        </div>
      </div>
      <svg-icon
        iconClass="close-white"
        class="notice-icon"
        @click="updateValue"
      />
    </div>
    <div @click="showAddressPopup">
      <div class="select-address">
        <div class="address-title">{{ renderTitle }}</div>
        <van-icon name="arrow" class="arrow" />
      </div>
      <div class="address-content" v-if="selectAddress.id">
        <span>{{ selectAddress.recipient_name }}</span>
        <span class="phone">{{ selectAddress.recipient_phone_number }}</span>
      </div>
    </div>
    <div class="matter-info" :class="{ 'has-address': !!selectAddress.id }">
      <van-image class="image" :src="selectSku.image_url" fit="contain" />
      <div class="content">
        <div class="title">{{ selectSku.item_name }}</div>
        <div class="price-wrap">
          <div class="price">
            <span class="unit">￥</span>
            <span>{{ selectSku.item_price }}</span>
          </div>
          <div class="face-value">
            <span>¥ {{ selectSku.face_value }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="draw-btn"
      @click="handleDraw"
      :class="{ disabled: !selectAddress.id }"
    >
      {{ drawBtnText }}
    </div>
  </van-popup>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";
import throttle from "lodash.throttle";
import Vue from "vue";
import * as pickBy from "lodash.pickby";
import qs from "qs";
import CheckPostage from "./CheckPostage/index";

import { useStore, useRouter, useRoute } from "@/components/use/base";
import { activateBenefit, querySkuStock } from "@/apis/home";
import { getBenefitInfo, getPointList } from "@/apis";
import ans from "@/utils/ans";

const vm = Vue.prototype;

export default defineComponent({
  props: ["show", "selectSku", "benefitInfo", "addressList", "selectAddress"],
  setup(props, { emit }) {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    const userInfo = computed(() => store.state.userInfo);
    const source = computed(() => store.state.source);

    const updateValue = () => {
      emit("update:show", false);
    };

    const showAddressPopup = () => {
      emit("showAddressPopup");
    };

    const renderTitle = computed(() => {
      if (props.selectAddress.id) {
        const { province, city, state, address } = props.selectAddress;
        return `${province}${city}${state}${address}`;
      }
      return "请选择你的收货地址";
    });

    const drawBtnText = computed(() => {
      const price = Number(props.selectSku.item_price);
      return price > 0 ? "立即购买" : "立即领取";
    });

    const isFree = computed(() => {
      const price = Number(props.selectSku.item_price);
      return price === 0;
    });

    const fetchBenefitInfo = async (params) => {
      try {
        const res = await getBenefitInfo(params);
        emit("update:benefitInfo", res.data);
        return res;
      } catch (e) {
        return { data: {} };
      }
    };

    const handleBrPoint = async (params) => {
      const brUseNewPoint = vm.$isConfigValueQueryByNamespaceGroup(
        "NAMESPACE_GROUP_USE_NEW_POINT"
      );
      if (!brUseNewPoint) return true;
      const { point_unique_id } = route.query;

      const { data: pointList } = await getPointList({
        benefit_type: props.benefitInfo.type,
        only_available: true,
      });

      let pointObj =
        pointList?.find((item) => item.point_unique_id == point_unique_id) ||
        pointList.filter((item) => item.point_status === "pending")[0];
      if (pointObj?.point_status === "pending") {
        params.point_unique_id = pointObj.point_unique_id;
        return true;
      }
      vm.$toast("您已经使用过此权益");
      return false;
    };

    const toPay = async () => {
      // 跳转收银台
      const params = pickBy(
        {
          source: source.value,
          item_code: props.selectSku.item_code,
          price: props.selectSku.item_price,
          item_name: decodeURIComponent(props.selectSku.item_name),
          sku_name: decodeURIComponent(props.selectSku.item_name),
          type: props.benefitInfo.type,
          detail_type: props.selectSku.item_name,
          recharge_account_type: props.selectSku.recharge_account_number || 0,
          benefit_category: props.selectSku.benefit_category,
          address_id: props.selectAddress.id,
        },
        (v) => v !== undefined
      );
      const canUsePoint = await handleBrPoint(params);
      if (!canUsePoint) return;
      router.push(`/pay?${qs.stringify(params, { encode: false })}`);
    };

    const handleDraw = throttle(
      async () => {
        console.log(props.selectAddress.province);
        if (
          [
            "内蒙古自治区",
            "吉林省",
            "甘肃省",
            "青海省",
            "宁夏回族自治区",
            "海南省",
          ].includes(props.selectAddress.province)
        ) {
          const accept = await CheckPostage.show();
          if (!accept) return;
        }
        if (!props.selectAddress.id) {
          vm.$toast("请选择收货地址");
          return;
        }
        if (!userInfo.value.is_member) {
          vm.$toast("您还不是会员，开通会员即可享受特惠权益。");
          return;
        }
        // 查询库存
        try {
          const stock = await querySkuStock({
            item_code: props.selectSku.item_code,
            user_id: userInfo.value.id,
            hideMsg: true,
          });
          if (
            stock.data.daily_stocks <= 0 ||
            stock.data.partner_stocks <= 0 ||
            stock.data.saleable_stocks <= 0 ||
            stock.data.user_daily_stocks <= 0 ||
            !stock.data.status
          ) {
            vm.$toast("该商品暂时无货，请明天再来或咨询客服");
            return;
          }
        } catch (e) {
          console.log(e);
        }

        // 判断有没有可用的点数
        if (
          props.benefitInfo.amount_available <= 0 &&
          props.benefitInfo.amount_reserved
        ) {
          vm.$alert({
            message: "您本月已用过此权益，请下个月再来",
            confirmButtonText: "好的",
          });
          return;
        }

        // 可用次数
        if (
          props.benefitInfo.amount_available <= 0 &&
          !props.benefitInfo.amount_reserved
        ) {
          vm.$alert({
            message: "剩余可用次数不足，可前往订单查看已获取的实物权益。",
            confirmButtonText: "去查看",
          }).then(() => {
            router.push("/order");
          });
          return;
        }

        //需要购买的权益判断是否是非法权益
        if (
          props.selectSku.top_up_type === 1 ||
          props.selectSku.top_up_type === 3
        ) {
          const params = pickBy(
            {
              benefit_type: props.benefitInfo.type,
              benefit_source: props.benefit_source || "会员权益",
              is_zero_pay: true,
              order_name: props.selectSku.item_name,
              item_code: props.selectSku.item_code,
              top_up_type: props.selectSku.top_up_type,
              detail_type: props.selectSku.item_name,
              activation_platform: props.selectSku.activation_platform,
              source: source.value,
              pre_activate: true,
            },
            (v) => v !== undefined
          );
          if (isFree.value) {
            params.address_id = props.selectAddress.id;
            params.benefit_category = props.selectSku.benefit_category;
            params.pre_activate = undefined;
          }
          const canUsePoint = await handleBrPoint(params);
          if (!canUsePoint) return;
          const res = await activateBenefit(params);
          if (isFree.value) {
            await fetchBenefitInfo({ benefit_type: props.benefitInfo.type });
            await store.dispatch("fetchUserInfo");
            ans.track("matter_benefit_activate", {
              benefit_type: props.benefitInfo.type,
              item_code: props.selectSku.item_code,
            });
            emit("update:show", false);
            vm.$alert({
              message: "您已成功领取会员兑换码，<br/>请在我的订单中查看并使用",
              confirmButtonText: "去查看",
            }).then(() => {
              router.push(
                `/matterDetail?order_number=${res.data.order_number}&from=activate`
              );
            });
          }
        }
        if (!isFree.value) toPay();
      },
      1500,
      { trailing: false }
    );

    return {
      renderTitle,
      drawBtnText,
      handleDraw,
      updateValue,
      showAddressPopup,
    };
  },
});
</script>

<style lang="less" scoped>
.draw-wrap {
  width: 100%;
  height: 357px;
  background: #f8f8f8;
  border-radius: 24px 24px 0px 0px;
  box-sizing: border-box;
  padding: 0 24px;
  overflow: hidden;
}

.notice-wrap {
  height: 36px;
  background: linear-gradient(180deg, #ffddce 0%, #f8f8f8 100%);
  border-radius: 16px 16px 0px 0px;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;

  .notice-text-wrap-container {
    overflow: hidden;
    width: 100%;
  }

  .notice-icon {
    margin-left: 16px;
    margin-right: 12px;
    font-size: 12px;
    flex-shrink: 0;
  }

  .notice-text-wrap {
    flex-shrink: 0;
    font-weight: 400;
    font-size: 12px;
    color: #ff5001;
    line-height: 16px;
    white-space: nowrap;
    word-break: keep-all;
    width: max-content;
    animation: scroll 7s linear infinite;
  }

  @keyframes scroll {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(-50%);
    }
  }
}

.select-address {
  display: flex;
  justify-content: space-between;
  margin-top: 36px;
  align-items: center;

  .address-title {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 24px;
  }

  .arrow {
    font-weight: 600;
    font-size: 14px;
    color: #000000;
  }
}

.address-content {
  margin-top: 8px;
  color: #cccccc;
  font-size: 12px;
  line-height: 16px;

  .phone {
    margin-left: 12px;
  }
}

.matter-info {
  margin: 0 auto;
  margin-top: 43px;
  height: 96px;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  display: flex;

  &.has-address {
    margin-top: 24px;
  }

  .image {
    display: block;
    width: 80px;
    height: 80px;
    margin: 9px 0px 7px 8px;
  }

  .content {
    margin-top: 16px;
    margin-left: 8px;

    .title {
      font-weight: 500;
      font-size: 14px;
      color: #000000;
      line-height: 18px;
    }

    .price-wrap {
      display: flex;
      align-items: flex-end;
      margin-top: 16px;
      .price {
        font-weight: 600;
        font-size: 24px;
        color: #fa541c;
        .unit {
          font-size: 16px;
        }
      }

      .face-value {
        font-weight: 400;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.4);
        margin-left: 12px;
        margin-bottom: 2px;
        text-decoration: line-through;
      }
    }
  }
}

.draw-btn {
  margin-top: 67px;
  height: 44px;
  background: linear-gradient(115deg, #dfbd94 0%, #ffe8c8 100%);
  border-radius: 21px;
  text-align: center;
  font-weight: 500;
  font-size: 16px;
  color: #6c3e0c;
  line-height: 44px;
  margin-bottom: 40px;

  &.disabled {
    background: #ececec;
    color: #252525;
  }
}
</style>
